<script>
    import { onMount } from "svelte";
    import { checkTokenExpiration } from "../../Utils/utilFunctions.svelte";
    import { PageLoading } from "../../Components/Common/index.svelte";

    export let tokenRefresh = undefined;

    onMount(async () => {
        tokenRefresh = checkTokenExpiration();
    });
</script>

<div class="flex flex-1 items-center justify-center">
    <PageLoading />
</div>
